import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=366af1ef&scoped=true"
import script from "./settlement.vue?vue&type=script&lang=js"
export * from "./settlement.vue?vue&type=script&lang=js"
import style0 from "./settlement.vue?vue&type=style&index=0&id=366af1ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366af1ef",
  null
  
)

export default component.exports